import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { NotificationsProvider } from '../../providers/notifications-provider';
import { NotificationService } from '../../notification.service';
import { MatIconButton, MatMiniFabButton } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { MatMenu, MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { NgForOf, NgIf } from "@angular/common";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatDivider } from "@angular/material/divider";
import { DateClosestPipe } from "../../../common/pipes/date-closest";
import { EllipsizePipe } from "../../../common/pipes/ellipsize";
import { Notification } from "../../../common/models/notification";

@Component({
  selector: 'notifications-notifications-menu',
  providers: [],
  styleUrls: ['./notifications-menu.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    NgIf,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    MatMiniFabButton,
    MatIconButton,
    MatProgressSpinner,
    MatDivider,
    NgForOf,
    DateClosestPipe,
    EllipsizePipe,
  ],
  templateUrl: './notifications-menu.html'
})
export class NotificationsNotificationsMenuComponent implements AfterViewInit {
    public isMarkAllSeenLoading = false;
    constructor(
        public notificationsProvider: NotificationsProvider,
        public conf: ConfigProvider,
        private _router: Router,
        private notificationService: NotificationService
    ) {
    }

    public ngAfterViewInit() {

    }

    public onNotificationClicked(event:any, notification: Notification): void {
        event.stopPropagation();
        this.notificationsProvider.markSeen([notification]).subscribe({
            error: (error: any) => this.onError(error)
          }
        );

        if (notification.data?.discussion_id) {
            this.notificationService.notificationClicked(notification);
            return;
        }

        if (notification.data?.linkUrl?.startsWith(this.conf.appUrl)) {
            this._router.navigateByUrl(notification.data.linkUrl.substring(this.conf.appUrl.length));
        } else if (notification.data?.linkUrl) {
            window.open(notification.data.linkUrl, '_blank');
        }
    }

    public onMarkAllReadClicked(event: any): void {
        event.stopPropagation();
        this.isMarkAllSeenLoading = true;
        this.notificationsProvider.markSeen(this.notificationsProvider.unSeenNotifications).subscribe({
          next: () => this.isMarkAllSeenLoading = false,
          error: (error: any) => this.onError(error)
        })
    }

    private onError(error: any): void {
        this.isMarkAllSeenLoading = false;
    }
}
